import { useEffect } from 'react';

export const SITE_URL = 'https://www.idealizer.com.br';

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Metadados de SEO por página (o site é uma SPA: o index.html é único).
 * Atualiza título, descrição, canônico próprio da rota, Open Graph e robots.
 *
 * @param {object} seo
 * @param {string} seo.title        título da aba e do resultado de busca
 * @param {string} seo.description  descrição única da página
 * @param {string} seo.path         caminho canônico (ex.: '/sobre')
 * @param {boolean} [seo.noindex]   true para páginas que não devem ser indexadas (404)
 */
export default function useSeo({ title, description, path, noindex = false }) {
  useEffect(() => {
    const url = `${SITE_URL}${path === '/' ? '/' : path}`;
    document.title = title;
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }
    setMeta('property', 'og:title', title);
    setMeta('name', 'twitter:title', title);
    setMeta('property', 'og:url', url);
    setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
    if (noindex) {
      const el = document.head.querySelector('link[rel="canonical"]');
      if (el) el.remove();
    } else {
      setCanonical(url);
    }
  }, [title, description, path, noindex]);
}
